<div class="header">
    <h2>{{ 'organisations.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="organisations-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'organisations.error.unavailable' | translate" />
} @else if (organisation(); as organisation) {
    <div class="body">
        <div class="entity-header">
            <app-avatar [image]="organisation.logoMediaId | mediaSrc | async" [label]="organisation.name.charAt(0)" size="lg" />
            <div class="entity-identity">
                <h1>{{ organisation.name }}</h1>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'organisations.fieldset.contact' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'organisations.form.contactName' | translate }}</span>
                @if (organisation.contactName) {
                    <span class="value">{{ organisation.contactName }}</span>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
            <div class="field">
                <span class="label">{{ 'organisations.form.contactEmail' | translate }}</span>
                @if (organisation.contactEmail) {
                    <a class="value" [href]="'mailto:' + organisation.contactEmail">{{ organisation.contactEmail }}</a>
                } @else {
                    <span class="value empty">{{ 'common.notProvided' | translate }}</span>
                }
            </div>
        </div>

        <div class="section">
            <h2>{{ 'organisations.fieldset.admins' | translate }}</h2>
            @for (admin of organisation.admins; track admin.id) {
                <a class="admin" [routerLink]="['/', { outlets: { modal: ['users', 'view', admin.id] } }]" data-test="organisations-view-admin">
                    <i class="pi pi-user"></i>
                    {{ admin.name }}
                </a>
            } @empty {
                <p class="admin-missing">{{ 'organisations.admin.missing' | translate }}</p>
                <a
                    class="admin-create"
                    [routerLink]="['/', { outlets: { modal: ['users', 'add', createAdminParams()] } }]"
                    data-test="organisations-view-create-admin"
                >
                    <i class="pi pi-user-plus"></i>
                    {{ 'organisations.admin.create' | translate }}
                </a>
            }
        </div>

        <div class="section">
            <h2>{{ 'organisations.fieldset.schools' | translate }}</h2>
            <app-entity-list [ids]="organisation.schoolIds" type="school" emptyKey="organisations.schools.empty" />
        </div>
    </div>

    <div class="footer">
        <app-delete-button [organisationId]="organisation.id" [saving]="saving()" testId="organisations-view-delete" />
        <p-button [label]="'organisations.detail.edit' | translate" icon="pi pi-pencil" data-test="organisations-view-edit" (onClick)="onEdit()" />
    </div>
}
